<button type="button" #statusHistoryDrawerButton command="show-modal" commandfor="statusHistoryDrawer"
    class="group inline-flex items-center gap-x-1 rounded-md bg-transparent px-2.5 py-1.5 text-sm font-semibold text-gray-700 transition-all ease-in-out duration-300">

    <atom-application-status-badge [applicationStatus]="applicationStatus"></atom-application-status-badge>

    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="size-5 transition-transform duration-300 ease-in-out group-hover:translate-x-1">
        <path d="m9 18 6-6-6-6" />
    </svg>
</button>



<el-dialog>
    <dialog #statusHistoryDrawerDialog id="statusHistoryDrawer" aria-labelledby="statusHistoryDrawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">

                        <!-- header -->
                        <div class="px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary">
                                        Application Status History
                                    </p>
                                    <p class="text-sm text-secondary">
                                        View the status history of the application.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="fab-button-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-zinc-200 dark:divide-zinc-800">



                            <!-- Status History List -->
                            <div class="flex-1 flex flex-col h-full overflow-y-auto scrollbar-transparent">

                                @if (statusHistory && statusHistory.length > 0) {
                                <div class="flow-root w-full p-6">
                                    <ul role="list" class>
                                        @for (status of statusHistory; track $index) {
                                        @if (status.status != 7) {
                                        <li>

                                            <div class="flex justify-between">
                                                <div class="relative"
                                                    [class]="$index == statusHistory.length -1 ? 'pb-1' : 'pb-6'">
                                                    <div class="absolute left-4 top-[45px] -ml-px h-[15px] w-0.5 bg-gray-200 dark:bg-zinc-600"
                                                        aria-hidden="true" [hidden]="$index == statusHistory.length -1">
                                                    </div>
                                                    <div class="relative flex space-x-3 items-center">
                                                        <div class="flex gap-3 items-center justify-center">
                                                            <div
                                                                class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white dark:ring-zinc-800 test-white dark:test-zinc-800"
                                                                [class]="miscService.getStatusColour(status.status)">
                                                                <!-- Invited -->
                                                                @switch (status.status) {
                                                                @case (1) {
                                                                <!-- *** INVITED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <path
                                                                        d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                                    <circle cx="9" cy="7" r="4" />
                                                                    <line x1="19" x2="19" y1="8" y2="14" />
                                                                    <line x1="22" x2="16" y1="11" y2="11" />
                                                                </svg>
                                                                }
                                                                @case (2) {
                                                                <!-- *** APPLIED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                                                                    viewBox="0 0 24 24" stroke-width="1.5"
                                                                    stroke="currentColor" class="size-5">
                                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                                        d="M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672Zm-7.518-.267A8.25 8.25 0 1 1 20.25 10.5M8.288 14.212A5.25 5.25 0 1 1 17.25 10.5" />
                                                                </svg>

                                                                }
                                                                @case (3) {
                                                                <!-- *** HIRED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <path d="M12 12h.01" />
                                                                    <path
                                                                        d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                                                                    <path d="M22 13a18.15 18.15 0 0 1-20 0" />
                                                                    <rect width="20" height="14" x="2" y="6" rx="2" />
                                                                </svg>
                                                                }
                                                                @case (4) {
                                                                <!-- *** READY TO POST *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <path d="M12 2v13" />
                                                                    <path d="m16 6-4-4-4 4" />
                                                                    <path
                                                                        d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                                                </svg>
                                                                }
                                                                @case (5) {
                                                                <!-- *** POSTED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="m9 12 2 2 4-4" />
                                                                </svg>
                                                                }
                                                                @case (6) {
                                                                <!-- *** COMPLETED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                                                                    <path d="m9 11 3 3L22 4" />
                                                                </svg>
                                                                }
                                                                @case (8) {
                                                                <!-- *** PAID HIDDEN FROM CREATE PANEL *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <path
                                                                        d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                                                                    <rect x="2" y="6" width="14" height="12" rx="2" />
                                                                </svg>
                                                                }
                                                                @case (9) {
                                                                <!-- *** INVITE DECLINED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="m15 9-6 6" />
                                                                    <path d="m9 9 6 6" />
                                                                </svg>
                                                                }
                                                                @case (10) {
                                                                <!-- *** INVITE DECLINED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="m15 9-6 6" />
                                                                    <path d="m9 9 6 6" />
                                                                </svg>
                                                                }
                                                                @case (12) {
                                                                <!-- *** BONUS PAID *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path
                                                                        d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                                                                    <path d="M12 18V6" />
                                                                </svg>
                                                                }
                                                                @case (13) {
                                                                <!-- *** APPLICATION DECLINED *** -->
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="size-5">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="m15 9-6 6" />
                                                                    <path d="m9 9 6 6" />
                                                                </svg>
                                                                }
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="flex-col">
                                                            <div
                                                                class="flex flex-col min-w-0 flex-1 justify-between space-y-1">
                                                                <div>
                                                                    <p class="text-sm text-primary">{{
                                                                        miscService.getInviteStatus(status.status) }}
                                                                    </p>
                                                                    @if (status.video_name) {
                                                                    <p class="text-xs text-secondary flex gap-1">
                                                                        <span>Resource:</span>
                                                                        <span class="font-semibold">{{ status.video_name
                                                                            }}</span>
                                                                    </p>
                                                                    }
                                                                </div>
                                                                <div class="whitespace-nowrap text-xs text-secondary">
                                                                    <time datetime="2020-09-20">{{ status.createdDate |
                                                                        date:'dd MMM HH:mm' }}
                                                                    </time>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--                      @if (status.showRevert) {-->
                                                <!--                        <button class="btn-fab btn-fab-sm btn-alert mt-[6px]" [appTooltip]="'Revert to ' + miscService.getInviteStatus(status.status)" position="bottom">-->
                                                <!--                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-banana-icon lucide-banana"><path d="M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5"/><path d="M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z"/></svg>-->
                                                <!--                        </button>-->
                                                <!--                      }-->
                                            </div>


                                        </li>
                                        }
                                        }
                                    </ul>
                                </div>
                                } @else if (statusHistory && statusHistory.length == 0) {

                                } @else {

                                }

                                @if (selectedApplication && canUnhireApplication(applicationStatus, isShoutAgencyAdmin)) {
                                <div class="shrink-0 w-full px-6 pb-6 flex flex-wrap items-center gap-3">
                                    <atom-decline-application-drawer
                                        [applicationStatus]="selectedApplication.applicationStatus"
                                        [selectedApplication]="selectedApplication"></atom-decline-application-drawer>
                                    <p class="m-0 max-w-xs text-xs text-secondary">
                                        @if (isShoutAgencyAdmin) {
                                        Available while Hired, Started, Ready to post, Posted, or Completed.
                                        } @else {
                                        Available only while Hired — not once Started or later.
                                        }
                                    </p>
                                </div>
                                }

                            </div>
                            <!-- Status History List - END -->











                        </div>
                        <!-- main content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>